import React from "react";
import './internalFooters.css'
function Footer() {
  return (
    <div className="footerUser">
      <span style={{fontSize:'17px'}}>
        If you have any inquiries, please feel free to contact us at{" "}
        <a href={`mailto:${process.env.REACT_APP_ADMIN_EMAIL}`}>
          {process.env.REACT_APP_ADMIN_EMAIL}
        </a>
      </span>
      <br />
      <div className="container">
        <div id="footer-info" style={{fontSize:'14px', marginTop:'0.4rem'}}>
          © 2023 DataToBiz
          <span className="trademark">
            <sup>TM</sup>
          </span>{" "}
          All Rights Reserved
        </div>
      </div>
    </div>
  );
}

export default Footer;
